<header class="nav" [class.nav--transparent]="transparent" [class.nav--open]="menuOpen()">
  <div class="nav__inner">
    <button
      type="button"
      class="nav__burger"
      (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen()"
      aria-label="Toggle menu"
    >
      <span></span><span></span><span></span>
    </button>

    <a routerLink="/" class="nav__brand" (click)="closeAll()">
      <span class="nav__brand-name">HNH</span>
      <span class="nav__brand-sub">Jewellery</span>
    </a>

    <nav class="nav__links" [class.nav__links--open]="menuOpen()">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeAll()">Home</a>

      <div
        class="nav__dropdown"
        [class.nav__dropdown--open]="shopOpen()"
        (mouseenter)="shopOpen.set(true)"
        (mouseleave)="shopOpen.set(false)"
      >
        <a routerLink="/shop" routerLinkActive="active" (click)="closeAll()">
          Shop
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
        </a>
        <button type="button" class="nav__dropdown-toggle" (click)="shopOpen.set(!shopOpen())" aria-label="Toggle shop categories"></button>
        <div class="nav__dropdown-menu">
          <a [routerLink]="['/shop']" (click)="closeAll()">All Jewellery</a>
          @for (category of categories(); track category.id) {
            <a [routerLink]="['/shop']" [queryParams]="{ category: category.slug }" (click)="closeAll()">
              {{ category.name }}
            </a>
          }
          <a class="nav__dropdown-highlight" [routerLink]="['/shop']" [queryParams]="{ filter: 'sale' }" (click)="closeAll()">On Sale</a>
        </div>
      </div>

      <a routerLink="/collections" routerLinkActive="active" (click)="closeAll()">Collections</a>
      <a routerLink="/about" routerLinkActive="active" (click)="closeAll()">About</a>
      <a routerLink="/contact" routerLinkActive="active" (click)="closeAll()">Contact</a>
    </nav>

    <div class="nav__actions">
      <button type="button" class="nav__icon" (click)="toggleSearch()" aria-label="Search">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
        </svg>
      </button>

      <a routerLink="/wishlist" class="nav__icon" aria-label="Wishlist" (click)="closeAll()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M12 21s-7.5-4.8-10-9.3C.4 8.4 2.4 4.5 6.2 4.5c2.2 0 3.9 1.2 4.8 3 1-1.8 2.7-3 4.9-3 3.7 0 5.7 3.9 4.1 7.2C19.5 16.2 12 21 12 21z"/>
        </svg>
        @if (wishlist.count() > 0) {
          <span class="nav__badge">{{ wishlist.count() }}</span>
        }
      </a>

      <a routerLink="/cart" class="nav__icon" aria-label="Cart" (click)="closeAll()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M6 7h12l1.2 12.2a1 1 0 01-1 1.1H5.8a1 1 0 01-1-1.1L6 7z"/>
          <path d="M9 10V6a3 3 0 016 0v4"/>
        </svg>
        @if (cart.itemCount() > 0) {
          <span class="nav__badge">{{ cart.itemCount() }}</span>
        }
      </a>
    </div>
  </div>

  @if (searchOpen()) {
    <div class="nav__search">
      <div class="nav__search-inner">
        <form class="nav__search-bar" (ngSubmit)="submitSearch()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
          </svg>
          <input
            type="search"
            name="q"
            placeholder="Search necklaces, rings, bracelets…"
            [ngModel]="searchTerm()"
            (ngModelChange)="onSearchInput($event)"
            autocomplete="off"
            autofocus
          />
          <button type="button" class="nav__search-close" (click)="toggleSearch()" aria-label="Close search">&times;</button>
        </form>

        @if (searching()) {
          <p class="nav__search-note">Searching…</p>
        } @else if (searchResults().length > 0) {
          <ul class="nav__search-results">
            @for (product of searchResults(); track product.id) {
              <li>
                <button type="button" (click)="goToProduct(product)">
                  @if (product.thumbnail_url) {
                    <img [src]="product.thumbnail_url" [alt]="product.name" loading="lazy" />
                  }
                  <span class="nav__search-name">{{ product.name }}</span>
                  <span class="nav__search-price">Rs {{ salePrice(product.price, product.discount) | number: '1.0-0' }}</span>
                </button>
              </li>
            }
          </ul>
          <button type="button" class="nav__search-all" (click)="submitSearch()">View all results →</button>
        } @else if (searchTerm().trim().length >= 2) {
          <p class="nav__search-note">No pieces found for “{{ searchTerm() }}”.</p>
        }
      </div>
    </div>
  }
</header>

@if (menuOpen() || searchOpen()) {
  <div class="nav-overlay" (click)="closeAll()"></div>
}
